import React, { useEffect, useMemo, useState } from "react";
import { get } from "lodash";
import { observer } from "mobx-react-lite";

import i18next from "i18next";
import { Portal } from "react-portal";
import { countryList } from "_common/constants/statusType";

const ModalCountry = observer(({ onClose, onChange }) => {
  const [keyword, setKeyword] = useState("");

  const handleChange = (item) => {
    if (typeof onChange === "function") {
      onChange(item);
    }
    onClose();
  };

  const dataList = useMemo(
    () =>
      countryList?.filter((obj) =>
        obj?.name?.toLowerCase().includes(keyword?.toLowerCase())
      ),
    [keyword]
  );

  return (
    <Portal>
      <div className="modal modal-bet">
        <div className="min-h-screen bg-[#1C1C1E]">
          <div className="sticky z-50 top-0 left-0 w-full px-4 py-4 bg-[#100f14]">
            <div className=" flex items-center gap-2 mb-4">
              <div className="cursor-pointer" onClick={() => onClose()}>
                <svg width="25" height="24" viewBox="0 0 24 24" fill="#fff">
                  <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" />
                </svg>
              </div>
              <span className="text-[#fff]">
                {i18next.t(i18next.t("note5"))}
              </span>
            </div>
            <div className="relative w-fit px-2 flex items-center gap-2 bg-[#4C4B4F] rounded mt-4">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 19a8 8 0 100-16 8 8 0 000 16zM20.998 21l-4.35-4.35"
                  stroke="#FFF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <input
                className="p-2 text-[#fff] text-[14px] w-full bg-transparent border-none outline-none focus:bg-transparent placeholder:text-[#dfdfdf] placeholder:text-[14px] focus:outline-none"
                placeholder="Tìm kiếm quốc gia hoặc khu vực"
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e?.target?.value)}
              />
            </div>
          </div>
          <div
            className="flex flex-col overflow-auto"
            style={{ height: "calc(100vh - 109px)" }}
          >
            {dataList?.map((item) => (
              <div
                className="py-2 px-4 flex items-center justify-between cursor-pointer"
                key={item?.name}
                onClick={() => handleChange(item)}
              >
                <div className="flex items-center gap-4">
                  <img
                    className="w-[30px] h-[30px] rounded-full"
                    src={item?.flag}
                    alt=""
                  />
                  <div className="flex flex-col">
                    <span className="text-[#fff] text-[14px]">
                      {item?.name}
                    </span>
                  </div>
                </div>
                <span className="text-[#fff] text-[14px]">{item?.phone}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Portal>
  );
});

export default ModalCountry;
